import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_8CRed_8DBlue = () => <CrossRoad coords="2043.000000, 732.694374"/>;
export default CrossRoad_8CRed_8DBlue;
